<template>
  <div style="height: 100%;">
    

    <v-layout column justify-center align-center fill-height hide-details>

      <v-flex shrink class="pb-3">
        <v-row class="mb-2">
          <v-col v-for="circle in pinCodeCircles" :key="circle" class="shrink">
            <v-icon x-large :color="pinColor(circle)">{{ pinCodeStyle(circle) }}</v-icon>
          </v-col>
        </v-row>
      </v-flex>

      <v-col>
        <v-row justify="center" fill-height style="height: 100%">
          <v-col v-for="num in numbers" :key="num" class="col-4 text-center">
            <v-card  class="rounded-lg" height="100%" width="100%" color="primary" dark
              @pointerdown.stop.prevent="
                pointerMode && selectedNum(num, 1)
                " @click.stop.prevent="!pointerMode && selectedNum(num, 1)">


              <v-layout row fill-height align-center justify-center>
                <v-flex class="display-4" v-if="$vuetify.breakpoint.smAndDown">
                  {{ num }}
                </v-flex>
                <v-flex class="headline" v-else>
                  {{ num }}
                </v-flex>
              </v-layout>
            </v-card>
          </v-col>

          <v-col cols="8" class="text-center">
            <v-card class="rounded-lg" height="100%" color="primary" dark width="100%"
              @pointerdown.stop.prevent="
                pointerMode && selectedNum(0, 1)
                " @click.stop.prevent="!pointerMode && selectedNum(0, 1)">


              <v-layout row fill-height align-center justify-center>
                <v-flex class="display-4" v-if="$vuetify.breakpoint.smAndDown">
                  0
                </v-flex>
                <v-flex v-else class="headline"> 0 </v-flex>
              </v-layout>
            </v-card>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-card class="rounded-lg" height="100%" color="red" dark ripple elevation="10" width="100%"
            @pointerdown.stop.prevent="pointerMode && clearPin()" @click.stop.prevent="!pointerMode && clearPin()">

              <v-layout row fill-height align-center justify-center>
                <v-flex class="text-h4" v-if="$vuetify.breakpoint.smAndDown">
                  Clear
                </v-flex>
                <v-flex v-else class="headline"> C </v-flex>
              </v-layout>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'keypad-input',
  props: ['selectedEmployee'],
  data() {
    return {
      pointerMode: "PointerEvent" in window,
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      pinCodeCircles: [1, 2, 3, 4],
      pin: ""
    }
  },
  watch: {
    async pin() {
      if (this.pin.length === 4) {
        // this.$emit('pinValueSubmit', this.pin)
        this.$emit('pinValueSubmit', this.pin)

        // if (this.metadata && this.metadata.customClockIn.storeTimeClockImage) {

        //   this.image = await this.getImage();
        //   console.log('got image', this.image)
        //   if (this.image) this.image.status = this.status;
        // }
        // if (this.checkToken()) {
        //   console.log("have token", this.checkToken());
        //   this.submitWithToken();
        // } else {
        //   console.log("no token");
        //   this.submitWithNoToken();
        // }
      }
    },
  },
  methods: {
    clearPin() {
      this.pin = ""
    },
    selectedNum(num) {
      num = num.toString();
      this.pin = this.pin.concat(num).trim();
    },
    pinColor(num) {
      if (this.pin.length >= num) {
        return "secondary";
      }
      else {
        return "grey";
      }
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) {
        return "mdi-check-circle";
      }
      else {
        return "mdi-checkbox-blank-circle-outline";
      }
    },
  }
}
</script>

<style scoped></style>